import type { NnnRegistrationRowKenmerk } from '@/api';
import type { NandaDiagnoseKenmerken } from '@/services';
import type { NnnRowKenmerkGroep } from '../types/careplan-nnn.types';
import { KENMERK_SECTIE_ORDER, kenmerkenOfType } from './build-kenmerk-secties';
import { kenmerkKey } from './kenmerk-key';

export function buildRowKenmerkGroepen(
  rowKenmerken: NnnRegistrationRowKenmerk[],
  beschikbaar: NandaDiagnoseKenmerken | null
): NnnRowKenmerkGroep[] {
  return KENMERK_SECTIE_ORDER.map(({ type, titleKey }) => {
    const labels = new Map(
      (beschikbaar ? kenmerkenOfType(beschikbaar, type) : [])
        .filter(kenmerk => kenmerk.code !== null)
        .map(kenmerk => [String(kenmerk.code), kenmerk])
    );
    return {
      type,
      titleKey,
      items: rowKenmerken
        .filter(kenmerk => kenmerk.type === type)
        .map(kenmerk => {
          const match = labels.get(kenmerk.nnnKenmerkDbRef);
          return {
            key: kenmerkKey(type, kenmerk.nnnKenmerkDbRef),
            label: match?.omschrijving ?? kenmerk.nnnKenmerkDbRef,
            hint: match?.type ?? null,
            inactive: beschikbaar !== null && (match === undefined || match.isActive === false),
          };
        }),
    };
  }).filter(groep => groep.items.length > 0);
}
